import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CognitoService } from '../cognito/cognito.service';
import { RoleType } from '../role-type';


export const directionGuard: CanActivateFn = async (route, state) => {
  const cognitoService = inject(CognitoService);
  const roles = await cognitoService.getUserGroups();

  return roles.includes(RoleType.DIREZIONE) || roles.includes(RoleType.ADMIN);
};
